import script from "./CancelarReservaView.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelarReservaView.vue?vue&type=script&setup=true&lang=js"

import "./CancelarReservaView.vue?vue&type=style&index=0&id=38cef720&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38cef720"]])

export default __exports__